export default "__VITE_ASSET__ChtyH_xu__"